import React from 'react';
import PropTypes from 'prop-types';
import {FormattedDate} from 'react-intl';

import '../styles/calendar-cell.scss';

const CalendarCell = ({
  date,
  pickDate,
  selectionType,
  validDate,
  changeColorstart,
  changeColorend,
  highlight,
  changeColor,
  activeDate,
}) => {
  const handlePickDate = () => {
    pickDate(date, selectionType);
  };

  const today = new Date(Date.now());
  today.setHours(0, 0, 0, 0);

  let todayDate;
  if (date && today) {
    todayDate = date.valueOf() === today.valueOf();
  }

  /**
   * Dates Section
   *
   */
  const dateSection = date ? <FormattedDate value={date} day="numeric" /> : null;

  return (
    <div>
      <div className="CalendarDateCard__OuterContainer">
        <div
          className={`${
            changeColorstart
              ? 'CalendarDateCard__Container--Starthighlight'
              : changeColorend
              ? 'CalendarDateCard__Container--Endhighlight'
              : 'CalendarDateCard__Container'
          }`}
        >
          {dateSection && (
            <div
              role="button"
              className={`CalendarDateCard__Date ${!validDate ? 'CalendarDateCard__Date--Disable' : ''} ${
                todayDate ? 'CalendarDateCard__Datehover' : ''
              } ${highlight ? 'CalendarDateCard__Datehighlight' : ''} ${
                changeColorend || changeColorstart || changeColor || activeDate ? 'CalendarDateCard__Dateactive' : ''
              }`}
              onClick={handlePickDate}
              aria-label={date.getDate().toString()}
              disabled={!validDate}
            >
              {dateSection}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

CalendarCell.propTypes = {
  date: PropTypes.instanceOf(Date),
  pickDate: PropTypes.func,
  selectionType: PropTypes.string,
  validDate: PropTypes.any,
  activeDate: PropTypes.bool,
  changeColorstart: PropTypes.any,
  changeColorend: PropTypes.any,
  highlight: PropTypes.any,
  changeColor: PropTypes.any,
};

export default CalendarCell;
